module.exports = __webpack_public_path__ + "images/e251ca2629f251b52fa14007dd68ad7b-stayingLogoWhite.png";